<template>
    <div class="d-flex all-after-header-box">
        <!-- Левое меню модуля -->
        <div 
            :class="{'drawer-left-wrap' : true, 'dlw-large' : (!drawerLeftMenuMini), 'drawer-menu-hover': drawerLeftMenuHover }"
            @mouseenter="LeftMenuMouseenter()"
            @mouseleave="LeftMenuMouseleave()"
        >
            <v-navigation-drawer
                absolute
                permanent
                class="drawer-menu"
                v-model="drawerLeftMenu"
            >
                <template v-if="true">
                    <v-divider class="mr-2 ml-2"></v-divider>

                    <v-list
                        nav
                        dense
                        class="dm-actions-list"
                    >
                        <v-list-item-group
                            color="#009c95"
                        >
                            <v-list-item
                                link
                                class="v-item--active v-list-item--active drawer-menu-list-bigbtn"
                                @click="onCreateClicked"
                            >
                                <v-list-item-icon>
                                    <v-icon>mdi-plus-box</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t("Добавить") }}</v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </template>

                <!--Мои задания-->
                <v-list class="dm-list-header" nav dense shaped>   
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t('Мои_задания')}}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list nav dense shaped>
                    <v-list-group 
                        v-model="groups.inWork"
                        :accordion="true"
                        @input="closeOtherGroups('inWork')"
                    >
                        <template v-slot:prependIcon>
                            <v-icon>far fa-wrench</v-icon>
                        </template>
                        <template v-slot:activator>
                            <v-list-item-title>
                                {{ $t("В_работе") }} 
                                <sup 
                                    v-if="hasInWorkUread" style="color:#F04747;"
                                >
                                    &#x23FA;
                                </sup>
                            </v-list-item-title>
                        </template>
                        <template v-slot:appendIcon>
                            <v-icon>fas fa-chevron-down</v-icon>
                        </template>
                        <template v-for="inWorkItem in inWorkItems">
                            <v-list-item
                                link
                                :key="inWorkItem.type"
                                v-if="$validatePermission(inWorkItem.access)"
                                :to="{ name: 'CorrespondenceInWork', params: { collection: inWorkItem.collection }  }"
                            >
                                <v-list-item-icon>
                                    <v-icon></v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t(inWorkItem.name) }}</v-list-item-title>
                                
                                <div v-if="!drawerLeftMenuMini" :class="{'dm-counter': true, 'dm-counter-primary': inWorkItem.counter.unRead <= 0 || inWorkItem.type == 'chancellery', 'dm-counter-red': inWorkItem.counter.unRead > 0 && inWorkItem.type != 'chancellery' }">
                                    <v-progress-circular v-if="isCountersLoading && (inWorkItem.counter.total) <= 0" indeterminate :size="11" :width="2" color="primary" />
                                    <template v-else-if="inWorkItem.type !='chancellery' && inWorkItem.counter.unRead > 0">
                                        +{{ inWorkItem.counter.unRead }}
                                    </template>
                                    <template v-else-if="inWorkItem.counter.total > 0">
                                        {{ inWorkItem.counter.total }}
                                    </template>
                                </div>
                                
                            </v-list-item>
                        </template>

                    </v-list-group>

                    <v-list-item
                        link
                        :to="{ name: 'CorrespondenceHandled' }"
                    >
                        <v-list-item-icon>
                        <v-icon>far fa-cogs</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t("Обработанные") }}</v-list-item-title>
                    </v-list-item>
                </v-list>

               <!--Мои проекты-->
               <v-list class="dm-list-header" nav dense shaped>   
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t('Мои_проекты')}}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>                

                <v-list nav dense shaped>
                    <v-list-item-group>
                        
                        <v-list-item
                            v-for="projectItem in projectItems"
                            link
                            :key="projectItem.type"
                            :to="{ name: 'CorrespondenceProjects', params: { collection: projectItem.collection }  }"
                        >

                            <v-list-item-icon>
                                <v-icon>{{ projectItem.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t(projectItem.name) }}</v-list-item-title>
                            
                            <div v-if="!drawerLeftMenuMini" class='dm-counter dm-counter-primary'>
                                <template v-if="projectItem.count > 0">
                                    {{ projectItem.count }}
                                </template>
                            </div>
                            
                        </v-list-item>

                    </v-list-item-group>
                </v-list>

                <!--Документы-->
                <v-list class="dm-list-header" nav dense shaped>   
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t('Документы')}}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list
                    nav
                    dense
                    shaped
                >
                    <template 
                        v-for="correspondenceItem in correspondenceItems"
                    >
                    
                        <v-list-group 
                            v-if="correspondenceItem.children && correspondenceItem.children.length > 0"
                            v-model="groups[correspondenceItem.type]"
                            :key="'group-' + correspondenceItem.type"
                            :accordion="true"
                            @input="closeOtherGroups(correspondenceItem.type)"
                        >
                            <template v-slot:prependIcon>
                                <v-icon>{{ correspondenceItem.icon }}</v-icon>
                            </template>
                            <template v-slot:activator>
                                <v-list-item-title>
                                    {{ $t(correspondenceItem.name) }} 
                                    <sup 
                                        v-if="hasUnread(correspondenceItem)" style="color:#F04747;"
                                    >
                                        &#x23FA;
                                    </sup>
                                </v-list-item-title>
                            </template>
                            <template v-slot:appendIcon>
                                <v-icon>fas fa-chevron-down</v-icon>
                            </template>
                                <v-list-item
                                    v-for="innerItem in correspondenceItem.children"
                                    link
                                    :key="innerItem.type"
                                    :to="{ name: correspondenceItem.route, params: { collection: innerItem.type }  }"
                                >
                                    <v-list-item-icon>
                                        <v-icon></v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>{{ localized(innerItem.name) }}</v-list-item-title>
                                    
                                    <div v-if="!drawerLeftMenuMini" :class="{'dm-counter': true, 'dm-counter-primary': innerItem.counter.unRead <= 0, 'dm-counter-red': innerItem.counter.unRead > 0 }">
                                        <v-progress-circular v-if="isCountersLoading && (innerItem.counter.total) <= 0" indeterminate :size="11" :width="2" color="primary" />
                                        <template v-else-if="innerItem.counter.unRead > 0">
                                            +{{ innerItem.counter.unRead }}
                                        </template>
                                        <template v-else-if="innerItem.counter.total > 0">
                                            {{ innerItem.counter.total }}
                                        </template>
                                    </div>
                                    
                                </v-list-item>


                        </v-list-group>

                        <v-list-item
                            v-else                            
                            link
                            :key="'item-' + correspondenceItem.type"
                            :to="{ name: correspondenceItem.route }"
                        >
                            <v-list-item-icon>
                                <v-icon>{{ correspondenceItem.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t(correspondenceItem.name) }}</v-list-item-title>
                                <div v-if="!drawerLeftMenuMini" :class="{'dm-counter': true, 'dm-counter-primary': correspondenceItem.counter.unRead <= 0, 'dm-counter-red': correspondenceItem.counter.unRead > 0 }">
                                    <v-progress-circular v-if="isCountersLoading && (correspondenceItem.counter.total) <= 0" indeterminate :size="11" :width="2" color="primary" />
                                    <template v-else-if="correspondenceItem.counter.unRead > 0">
                                        +{{ correspondenceItem.counter.unRead }}
                                    </template>
                                    <template v-else-if="correspondenceItem.counter.total > 0">
                                        {{ correspondenceItem.counter.total }}
                                    </template>
                                </div>
                        </v-list-item>
                    </template>
                </v-list>

                <template v-if="allowSwetofor">
                    <!--Контроль-->
                    <v-list class="dm-list-header" nav dense shaped>   
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ $t('Контроль')}}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>

                    <v-list
                        nav
                        dense
                        shaped
                    >
                        <template>
                            <v-list-item
                                link
                                :to="{ name: 'CorrespondenceSvetofor' }"
                            >
                                <v-list-item-icon>
                                    <v-icon>far fa-traffic-light-go</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t('Светофор') }}</v-list-item-title>
                            </v-list-item>

                            <v-list-item
                                link
                                :to="{ name: 'CorrespondenceCompleted' }"
                            >
                                <v-list-item-icon>
                                    <v-icon>fa-regular fa-calendar-arrow-down</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t('Выполненные') }}</v-list-item-title>
                            </v-list-item>

                        </template>
                    </v-list>
                </template>
            </v-navigation-drawer>
        </div>

        <div class="content-box">

            <router-view :key="$route.fullPath" />
            
        </div>

        <CreateCorrespondenceDocumentModal ref="CreateDlg"/>
    </div>
</template>

<script>
import { mapGetters, mapActions} from 'vuex';
import CreateCorrespondenceDocumentModal from '@/components/documents/dialogs/CreateCorrespondenceDocumentDlg.vue';
import { httpAPI } from "@/api/httpAPI";

export default {
    name: "CorrespondenceMain",
    components: {
        CreateCorrespondenceDocumentModal
    },
    computed: {
        ...mapGetters({ drawerLeftMenuMini: 'isDrawerLeftMenuMinimized' }),
        hasInWorkUread() {
            return this.inWorkItems.reduce((sum, item) => {
                return sum + (item.counter?.unRead ?? 0);
            }, 0) > 0;
        },
        allowSwetofor(){
            return this.$store.getters['global/auth/getUserInfo'].Permissions?.includes('ExecutionControl');
        },
    },
    data: () => ({
        drawerLeftMenu: true,
        drawerLeftMenuHover: false,

        isCountersLoading: false,

        counterTimer: null,
        counterCacheSeconds: 5,
        counterLastUpdate: 0,

        groups: {
            inWork: true,
            correspondence_ord: false,
            correspondence_inner: false
        },
        inWorkItems: [
            { 
                type: "on_execution",
                collection: 'Documents.My.OnExecution',
                name: "Исполнить",
                counter: { total: 0, unRead: 0 },
                access: { permissions:[]}
            },
            { 
                type: "for_work",
                collection: 'Documents.My.OnInspect.Resolution',
                name: "Для_работы",
                counter: { total: 0, unRead: 0 },
                access: { permissions:[]}
            },
            { 
                type: "on_inspect",
                collection: 'Documents.My.OnInspect',
                name: "Рассмотреть",
                counter: { total: 0, unRead: 0 },
                access: { permissions:[]}
            },
            {
                type: "on_take_note",
                collection: 'Documents.My.OnTakeNote',
                name: "Ознакомиться",
                counter: { total: 0, unRead: 0 },
                access: { permissions: []}
            },
            { 
                type: "on_adjustment",
                collection: 'Documents.My.OnAdjustment',
                name: "Согласовать",
                counter: { total: 0, unRead: 0 },
                access: { permissions:[]}
            },
            {
                type: "on_sign",
                collection: 'Documents.My.OnSign',
                name: "Подписать",
                counter: { total: 0, unRead: 0 },
                access: { permissions:[]}
            },
            {
                type: "chancellery",
                collection: 'Documents.My.OnRegister',
                name: "Зарегистрировать",
                counter: { total: 0, unRead: 0 },
                access: { permissions: ["ChancelleryIncomingDocumentsList", "ChancelleryOutcomingDocumentsList", "ChancelleryInternalDocumentsList", "CanSignChancellery" ], strategy: 'HAS_ANY' }
            },
            {
                type: "on_check",
                collection: 'Documents.My.OnCheck',
                name: "Проверить",
                counter: { total: 0, unRead: 0 },
                access: { permissions:[]}
            },
            {
                type: "on_rework",
                collection: 'Documents.My.OnRework',
                name: "Доработать",
                counter: { total: 0, unRead: 0 },
                access: { permissions:[]}
            },
            {
                type: "on_control",
                collection: 'MyDocuments.OnControl',
                name: "На_контроле",
                counter: { total: 0, unRead: 0 },
                access: { permissions:[]}
            },
        ],
        projectItems: [
            { 
                type: "project_new",
                collection: 'NewProjects',
                name: "Новые",
                count: 0,
                icon: "fa-regular fa-folder-arrow-down"
            },
            { 
                type: "project_inwork",
                collection: 'InWorkProjects',
                name: "В_работе",
                count: 0,
                icon: "fa-regular fa-folder-gear"
            },
            { 
                type: "project_completed",
                collection: 'ClosedProjects',
                name: "Завершенные",
                count: 0,
                icon: "fa-regular fa-folder-check"
            },
        ],
        correspondenceItems: [
            {
                type: "correspondence_incoming",
                name: "Входящие",
                route: "CorrespondenceIncomings",
                icon: "far fa-inbox-in",
                children: [],
                counter: { total: 0, unRead: 0 },
            },
            {
                type: "correspondence_outgoing",
                name: "Исходящие",
                route: "CorrespondenceOutgoings",
                icon: "far fa-inbox-out",
                children: [],
                counter: { total: 0, unRead: 0 },
            },
            {
                type: "correspondence_ord",
                name: "ОРД",
                route: "CorrespondenceOrds",
                icon: "fa-regular fa-folder",
                children: [],
                counter: { total: 0, unRead: 0 },
            },
            {
                type: "correspondence_inner",
                name: "Внутренние",
                route: "CorrespondenceInners",
                icon: "fa-regular fa-folder",
                children: [],
                counter: { total: 0, unRead: 0 },
            },
            {
                type: "correspondence_favorites",
                name: "Избранные",
                route: "CorrespondenceFavorites",
                icon: "far fa-star",
                children: [],
                counter: -1,
            },
            /*{
                type: "dirord",
                name: "ДИРОРД",
                route: "CorrespondenceDirords",
                icon: "far fa-id-card-alt",
                access: { permissions: [] },
                counter: -1
            },
            {
                type: "incomingActItem",
                name: "Пункты_ДИРОРД",
                route: "CorrespondenceIncomingActItems",
                icon: "far fa-id-card",
                access: { permissions: [] },
                counter: -1
            },
            {
                type: "innerActItem",
                name: "Пункты_ОРД",
                route: "CorrespondenceInnerActItems",
                icon: "far fa-clipboard-list",
                access: { permissions: [] },
                counter: -1
            }*/
        ],
    }),
    methods: {
        ...mapActions('global/actionsource', ['loadDataSource']),
        LeftMenuMouseenter() {
            if (this.drawerLeftMenuMini)
                this.drawerLeftMenuHover = true;
        },
        LeftMenuMouseleave() {
            this.drawerLeftMenuHover = false;  
        },
        async onCreateClicked() {
            try
            {
                let { params } = await this.$refs.CreateDlg.open();
                if (params.createType == 'Chancellery.IncomingDocument'){
                    this.closeOtherGroups('inWork');
                    this.groups.inWork = true;
                    this.$store.commit('correspondence/SET_LIST', 'inWork');
                    this.$store.commit('correspondence/inWork/SET_COLLECTION', 'Documents.My.OnRegister');
                }
                else {
                    this.$store.commit('correspondence/projects/SET_COLLECTION', 'NewProjects');
                    this.$store.commit('correspondence/SET_LIST', 'projects');
                }
                await this.loadDataSource({ createType: params.createType, navigate: true, common: params.isCommon ?? false });
            }
            catch (ex)
            {
                console.log(ex);
            }
        },
        getTemplateTypes(type) {
            if (type == 'correspondence_ord')
                return this.ordTypes;
            else 
                return this.innerTypes;
        },
        async updateCounters() {
            if (this.isCountersLoading || this.$moment.duration(this.$moment().diff(this.$moment(this.counterLastUpdate))).asSeconds() < this.counterCacheSeconds)
                return;

            this.isCountersLoading = true;

            try
            {
                const response = await httpAPI({ url: `api/correspondence/inwork/counter.v2`, method: 'GET' });
                const inWorkCounter = response?.data?.Payload;

                if (inWorkCounter && Array.isArray(inWorkCounter)) {
                    this.inWorkItems.forEach(item => {
                        const count = inWorkCounter.find(c => c.Name == item.type);
                        if (count){
                            item.counter.total = count.Total ?? 0;
                            item.counter.unRead = count.Unread ?? 0;
                        }
                    });
                    this.projectItems.forEach(item => {
                        const count = inWorkCounter.find(c => c.Name == item.type);
                        if (count){
                            item.count = count.Total ?? 0;
                        }
                    });
                    this.correspondenceItems.forEach(item => {
                        if (item.children && item.children.length > 0){
                            item.children.forEach(child => {
                                const childCount = inWorkCounter.find(c => c.Name == child.type);
                                if (childCount){
                                    child.counter.total = childCount.Total ?? 0;
                                    child.counter.unRead = childCount.Unread ?? 0;
                                    item.counter.total += childCount.Total ?? 0;
                                    item.counter.unRead += childCount.Unread ?? 0;
                                }    
                            });
                        }
                        else {
                            const count = inWorkCounter.find(c => c.Name == item.type);
                            if (count){
                                item.counter.total = count.Total ?? 0;
                                item.counter.unRead = count.Unread ?? 0;
                            }
                        }
                    });
                }
            }
            finally
            {
                this.isCountersLoading = false;
                this.counterLastUpdate = Date.now();
            }
        },
        closeOtherGroups(groupName) {
            Object.keys(this.groups).forEach(key => {
                if (key != groupName)
                    this.groups[key] = false;
            });
        },
        localized(val) {
            let currentLocale = 'ru-RU';
            let otherLocale = 'kk-KZ';
            if (this.$i18n.locale == 'kk'){
                currentLocale = 'kk-KZ';
                otherLocale = 'ru-RU';  
            }
            if (val == null)
                return val;
            if (typeof val === 'string') 
                return this.$i18n.t(val);            
            else if (val[currentLocale] !== undefined)            
                return val[currentLocale];
            else if (val[otherLocale] !== undefined)
                return val[otherLocale];
            return null;
        },
        hasUnread(itemCollection){
            if (itemCollection.children){
                return itemCollection.children.reduce((sum, item) => {
                    return sum + (item.counter?.unRead ?? 0);
                }, 0) > 0;
            }
            else 
                return (itemCollection.counter?.unRead ?? 0) > 0
        },
    },
    async created() {
        const list = await this.$store.dispatch('documents/references/getReference', { id: 1041 }, { root: true });
        let ords = [];
        let inners = [];
        list.forEach(item => {
            let menu = {
                type: `inner_${item.id}`,
                name: item.id == 100 ? 'Прочие' : item.UniValue,
                counter: { total: 0, unRead: 0 },
            }
            if (item.id <= 2)
                ords.push(menu);
            else 
                inners.push(menu);
        });
        ords.sort((a, b) => { return this.localized(a.name).localeCompare(this.localized(b.name)); });
        inners.sort((a, b) => {
            // объект с id = 100 всегда в конце
            if (a.type === 'inner_100') return 1;
            if (b.type === 'inner_100') return -1;

            // сортировка по name с поддержкой кириллицы
            return this.localized(a.name).localeCompare(this.localized(b.name));
        });
        const ordItem = this.correspondenceItems
            .find(item => item.type === "correspondence_ord");

        if (ordItem) {
            ordItem.children = ords;
        }

        const innerItem = this.correspondenceItems
            .find(item => item.type === "correspondence_inner");

        if (innerItem) {
            innerItem.children = inners;
        }
        
        await this.updateCounters();
        
        this.counterTimer = setInterval(async () => {
            await this.updateCounters();
        }, 60000);
    },
    mounted() {
        this.$eventBus.$on('update_correspondents_counters', async () => {
            // await this.updateCounters();
        });
    },
    beforeDestroy() {
        clearInterval(this.counterTimer);
        this.$eventBus.$off('update_correspondents_counters');
    }
}
</script>